import { render, staticRenderFns } from "./NoArticleLogs.vue?vue&type=template&id=448abad0&"
import script from "./NoArticleLogs.vue?vue&type=script&lang=js&"
export * from "./NoArticleLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports